import React from "react";
import {Column, Table} from "react-virtualized";
import {CircularProgress} from "@material-ui/core";
import {tableScroll$} from "../../utils/tableScroll";
import ActionDropdown from '../ActionsDropdown';
import HeaderSelectDropdown from "../HeaderSelectDropdown";

export default (props) => {

  const {
    registerChild,
    onRowsRendered,

    width = 0,
    height = 0,

    constantWidth = 0,
    stretchedCols = 0,

    headerHeight = 0,
    rowHeight = 0,

    className,
    headerColClass,
    rowColClass,
    actionClass,
    colClass,
    noDataClass,

    rowCount = 0,

    columns = [],
    list = [],
    filtersParams = {},
    actions,

    filtersData,
    disableFilters,
    disableHeadFilters,
    onFiltersChange,
    update,

    loading
  } = props;

  const tableProps = {
    ref: registerChild,
    rowHeight,
    rowCount,
    width,
    height,
    className,
    headerHeight,
    onScroll: ({scrollTop, scrollHeight}) => {
      if (scrollHeight && scrollTop) tableScroll$.emit(scrollTop);
    },
    scrollTop: Number(tableScroll$.getValue() || 0),
    noRowsRenderer: () => {
      return (
        <div className={noDataClass}>
          {loading ? <CircularProgress /> : 'No Data'}
        </div>
      )
    },
    rowGetter: ({index}) => (list[index] || {}),
    rowRenderer: (props) => {
      const {
        className,
        columns,
        index,
        key,
        style,
        rowData
      } = props;

      const oddClass = index % 2 === 0 ? 'odd' : 'even'

      const a11yProps = {'aria-rowindex': index + 1};

      return (
        <div
          {...a11yProps}
          className={[className, oddClass].join(' ')}
          key={key}
          role="row"
          style={style}
        >
          {columns}
          {!!actions && (
            <div className={[actionClass, oddClass].join(' ')}>
              <ActionDropdown
                id={key}
                rowData={rowData}
                actions={actions}
                update={update}
              />
            </div>
          )}
        </div>
      );
    },
    onRowsRendered
  };

  const availableColWidthForStretch = width - constantWidth;

  const tableHeaderRender = ({label, dataKey, ...rest}) => {
    const selectsFilters = filtersParams.selects || {};

    return selectsFilters[dataKey] && !disableFilters && !disableHeadFilters
      ? (
        <HeaderSelectDropdown
          params={selectsFilters[dataKey]}
          filtersData={filtersData}
          onFiltersChange={onFiltersChange}
          label={label}
        />
      ) : (
        <span>{label}</span>
      )
  }

  const customTableCellRenderer = (dataHandler) => (props) => {
    const {cellData, rowData, columnIndex, rowIndex, ...rest} = props;

    return (
      <div key={`${rowIndex}-${columnIndex}`}>
        {dataHandler ? dataHandler(rowData, rowIndex) : cellData}
      </div>
    )
  };

  return (
    <Table {...tableProps}>
      {columns.map((col) => {
        const {width, dataKey, label, dataHandler} = col;

        return (
          <Column
            key={dataKey}
            label={label}
            dataKey={dataKey || ''}
            headerRenderer={tableHeaderRender}
            cellRenderer={customTableCellRenderer(dataHandler)}
            className={colClass}
            width={
              width
                ? width
                : (availableColWidthForStretch / stretchedCols)
            }
          />
        )
      })}
    </Table>
  )
}
